"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _moment = _interopRequireDefault(require("moment"));
var _vuePropertyDecorator = require("vue-property-decorator");
var _shipperIncome = require("@/api/shipper-income");
var _DetailIncome = _interopRequireDefault(require("./components/DetailIncome.vue"));
var ShipperIncome = /*#__PURE__*/function (_Vue) {
  function ShipperIncome() {
    var _this;
    (0, _classCallCheck2.default)(this, ShipperIncome);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ShipperIncome, [].concat(args));
    (0, _defineProperty2.default)(_this, "dataTable", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "loadingButton", false);
    (0, _defineProperty2.default)(_this, "queryParams", {
      page: 1,
      limit: 10
    });
    (0, _defineProperty2.default)(_this, "date", [(0, _moment.default)().format("YYYY-MM-DD"), (0, _moment.default)().format("YYYY-MM-DD")]);
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    return _this;
  }
  (0, _inherits2.default)(ShipperIncome, _Vue);
  return (0, _createClass2.default)(ShipperIncome, [{
    key: "tableTransfrom",
    get: function get() {
      var data = [];
      this.dataTable.forEach(function (e) {
        e.income = 0;
        e.totalOrder = 0;
        e.tours.forEach(function (tour) {
          e.income += tour.moneyShipFeePersonal;
          e.totalOrder += tour.orders.length;
        });
        e.totalTour = e.tours.length;
        data.push(e);
      });
      return data;
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchData();
    }
  }, {
    key: "handleView",
    value: function handleView(row) {
      this.$refs.detail.handleView(row);
    }
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.queryParams.from = this.date[0];
              this.queryParams.to = this.date[1];
              _context.next = 4;
              return _shipperIncome.shipperIncomeApi.findAll(this.queryParams);
            case 4:
              res = _context.sent;
              this.dataTable = res.data.shippers;
              this.total = res.data.total;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }, {
    key: "getSummaries",
    value: function getSummaries(_ref) {
      var data = _ref.data;
      var sum = [];
      sum[0] = "Tổng";
      sum[2] = 0;
      sum[3] = 0;
      sum[4] = 0;
      data.forEach(function (element) {
        sum[2] += +element.income;
        sum[3] += +element.totalTour;
        sum[4] += +element.totalOrder;
      });
      sum[2] = this.$formatNumberVN(sum[2]);
      sum[3] = this.$formatNumberVN(sum[3]);
      sum[4] = this.$formatNumberVN(sum[4]);
      return sum;
    }
  }]);
}(_vuePropertyDecorator.Vue);
ShipperIncome = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    DetailIncome: _DetailIncome.default
  }
})], ShipperIncome);
var _default = exports.default = ShipperIncome;